import React, {useEffect} from "react";
import {SVVLayoutBanner, SVVLayoutPageType, SVVLayoutPageWrapper} from "@komponentkassen/svv-layout";
import {SVVButtonCustom, SVVButtonRow} from "@komponentkassen/svv-button";
import {Link, Outlet, useNavigate} from "react-router-dom";
import {useApptekster} from "../../apptekst-context";
import {SVVHeading, SVVIngress} from "@komponentkassen/svv-text";

const Index = ({flyt}: {flyt: string}) => {
  const t = useApptekster();
  const navigate = useNavigate();
  
  useEffect(() => {
    if (flyt) {
      if (flyt === "endre") {
        navigate("endre/endretime");
      }
      if (flyt === "avbestill") {
        navigate("avbestill/avbestilltime");
      }
      if (flyt === "bestill") {
        navigate("bestill/trafikkstasjon");
      }
    }
    // eslint-disable-next-line
  }, [flyt])
  
  return (
    <>
      <SVVLayoutBanner 
        medium
        noPaddingTop
      >
        <SVVHeading level="h1">
          {t("timebestilling.oversikt-overskrift")}
        </SVVHeading>
        <SVVIngress>
          {t("timebestilling.oversikt-ingress")}
        </SVVIngress>
      </SVVLayoutBanner>
      <SVVLayoutPageWrapper>
        <SVVLayoutPageType medium>
          <SVVButtonRow>
            <SVVButtonCustom
              asElement={Link}
              href="bestill/tjeneste"
              hrefAttribute="to"
            >
              {t("timebestilling.bestill")}
            </SVVButtonCustom>
            <SVVButtonCustom
              asElement={Link}
              href="endre/endretime"
              hrefAttribute="to"
              color="secondary"
              style={{fontWeight: "600"}}
            >
              {t("timebestilling.endre")}
            </SVVButtonCustom>
            <SVVButtonCustom
              asElement={Link}
              href="avbestill/avbestilltime"
              hrefAttribute="to"
              color="secondary"
              style={{fontWeight: "600"}}
            >
              {t("timebestilling.avbestill")}
            </SVVButtonCustom>
            <Outlet />
          </SVVButtonRow>
          <h2>Fake innganger fra cms-et</h2>
          <h3>
            Bestill:
          </h3>
          <p>
            <a href="http://localhost:3000/bestill/trafikkstasjon">
              Tung teori
            </a>
          </p>
          <p>
            <a href="http://localhost:3000/bestill/trafikkstasjon">
              Teori
            </a>
          </p>
          <p>
            <a href="http://localhost:3000/bestill/trafikkstasjon">
              Førerkort
            </a>
          </p>
          <p>
            <a href="http://localhost:3000/bestill/trafikkstasjon">
              Registrering
            </a>
          </p>
          <h3>Endre</h3>
          <p>
            <a href="http://localhost:3000/endre/endretime">
              Endre time
            </a>
          </p>
          <h3>Avbestill</h3>
          <p>
            <a href="http://localhost:3000/avbestill/avbestilltime">
              Avbestille time
            </a>
          </p>
          <div className="responsive-spacing-top--xlarge">
            <SVVHeading level="h2">
              {t("timebestilling.send-bekreftelse-paa-nytt")}
            </SVVHeading>
            <div className="svv-knapperad  responsive-spacing-top--xsmall">
              <SVVButtonCustom
                asElement={Link}
                href="resend/resendtime"
                hrefAttribute="to"
                color="secondary"
                style={{fontWeight: "600"}}
              >
                {t("timebestilling.send-bekreftelse")}
              </SVVButtonCustom>
              <Outlet />
            </div>
          </div>
        </SVVLayoutPageType>
      </SVVLayoutPageWrapper>
    </>
  ) 
}

export default Index;